if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;

          // Apply discount code if provided
          const discountCode = this.dataset.discountCode;
          if (discountCode && discountCode.trim() !== '') {
            this.applyDiscountCode(discountCode.trim(), response);
          } else {
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cartNotification.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cartNotification.renderContents(response);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    applyDiscountCode(discountCode, cartResponse) {
      // First, get existing discount codes from cart
      fetch(`${window.shopUrl}/cart.js`)
        .then((response) => response.json())
        .then((cartData) => {
          // Get existing discount codes
          const existingDiscounts = cartData.discount_codes || [];
          const existingDiscountCodes = existingDiscounts.map(d => d.code || d).filter(Boolean);

          // Add the new discount code to the list (avoid duplicates)
          const allDiscountCodes = existingDiscountCodes.includes(discountCode)
            ? existingDiscountCodes
            : [...existingDiscountCodes, discountCode];

          // Get sections to update
          const sectionsToRender = this.cartNotification.getSectionsToRender();
          const sectionIds = sectionsToRender.map((section) => section.id);

          // Apply discount codes using cart_update_url
          const config = {
            ...fetchConfig('json'),
            body: JSON.stringify({
              discount: allDiscountCodes.join(','),
              sections: sectionIds,
            }),
          };

          return fetch(routes.cart_update_url, config);
        })
        .then((response) => response.json())
        .then((updatedResponse) => {
          // Update cart notification with refreshed data including discount
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                this.cartNotification.renderContents({
                  ...cartResponse,
                  sections: updatedResponse.sections || cartResponse.sections
                });
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cartNotification.renderContents({
              ...cartResponse,
              sections: updatedResponse.sections || cartResponse.sections
            });
          }
        })
        .catch(() => {
          // If discount application fails, still show the cart notification
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(cartResponse) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cartNotification.renderContents(cartResponse);
          }
        });
    }
  });
}
